import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  hero1, hero2, logoBekasi, logoEbphtb,logoInstagram,logoPembebasan,wbs,
  logoEsptpd, logoSimpad, ipbb, lpse,
} from "../../assets";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Footer, Header, SubFooter } from "../../components";
import BaseURL from "../../assets/utils/baseUrl";
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement,
  ArcElement, Title, Tooltip, Legend,
} from "chart.js";
import { Bar, Pie } from "react-chartjs-2";
import YouTube from "react-youtube";
import "./style.scss";

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

/* ─── Tiny icon components ─────────────────────────────────────── */
const IconPlay   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>;
const IconArrow  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>;
const IconCalendar = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconChart  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;

/* ─── Number formatter ─────────────────────────────────────────── */
const formatIDR = (x) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(x);

/* ══════════════════════════════════════════════════════════════════
   BERANDA
══════════════════════════════════════════════════════════════════ */
const Beranda = () => {
  useDocumentTitle("BAPENDA - Kota Bekasi");

  const [slideIndex, setSlideIndex] = useState(0);
  const [banner, setBanner]         = useState([]);
  const [berita, setBerita]         = useState([]);
  const [agenda, setAgenda]         = useState([]);
  const [beritaVideo, setBeritaVideo] = useState([]);
  const [youtubePlay, setYoutubePlay] = useState({});
  const [chartActive, setChartActive] = useState("PAD");
  const [pajak, setPajak]   = useState({ all:[], label:[], target:[], realisasi:[] });
  const [retribusi, setRetribusi] = useState({ all:[], label:[], target:[], realisasi:[] });
  const [pad, setPad] = useState({ tahun:"", label:[], pajak_daerah:0, retribusi_daerah:0, kd_yang_dipisahkan:0, lain_lain_pad:0 });
  const [mounted, setMounted] = useState(false);



  

  /* ── fetch ── */
  useEffect(() => {
    setMounted(true);

    // Histats
    window._Hasync = window._Hasync || [];
    window._Hasync.push(['Histats.start','1,4600114,4,28,115,60,00011000']);
    window._Hasync.push(['Histats.fasi','1']);
    window._Hasync.push(['Histats.track_hits','']);
    const hs = document.createElement('script');
    hs.type='text/javascript'; hs.async=true;
    hs.src='//s10.histats.com/js15_as.js';
    document.body.appendChild(hs);

    const get = (path, cb) =>
      fetch(BaseURL + path).then(r => r.json()).then(d => cb(d.data)).catch(() => {});

    
    get("index.php/api/Berita/?jumlah_item=4&key=bapenda123", (d) => {
    setBerita(Array.isArray(d) ? d : []);
    });
     get("index.php/api/Agenda/?jumlah_item=4&key=bapenda123", (d) => {
    setAgenda(Array.isArray(d) ? d : []);
    });
    get("index.php/api/Pajak/?jumlah_item=5",   d => makePajak(d, setPajak));
    get("index.php/api/Retribusi/?jumlah_item=5", d => makePajak(d, setRetribusi));
    get("index.php/api/Pad/?jumlah_item=1",     setPadArr);
    get("index.php/api/Banner",                 setBanner);
    get("index.php/api/Berita_Video?jumlah_item=3", d => {
      if (d?.length > 0) { setBeritaVideo(d); setYoutubePlay(d[0]); }
    });

    // Elfsight
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const s = document.createElement("script");
      s.src="https://elfsightcdn.com/platform.js"; s.async=true;
      document.body.appendChild(s);
    }

    setTimeout(() => window.scrollTo({ top:0, behavior:"smooth" }), 100);
  }, []);

 
  /* ── auto-slide ── */
  useEffect(() => {
    if (!banner.length) return;
    const t = setTimeout(
      () => setSlideIndex(p => (p === banner.length - 1 ? 0 : p + 1)),
      5000
    );
    return () => clearTimeout(t);
  }, [slideIndex, banner]);

  /* ── helpers ── */
  const makePajak = (arr, setter) => {
    if (!arr?.length) return;
    setter({
      all: arr,
      label: arr.map(i => i.tahun),
      target: arr.map(i => i.target),
      realisasi: arr.map(i => i.realisasi),
    });
  };
  const setPadArr = (arr) => {
    if (!arr?.length) return;
    const p = arr[0];
    setPad({
      tahun: p.tahun,
      label: ["Pajak Daerah","Retribusi Daerah","Kekayaan Daerah Dipisahkan","Lain-lain PAD"],
      pajak_daerah: p.pajak_daerah,
      retribusi_daerah: p.retribusi_daerah,
      kd_yang_dipisahkan: p.kd_yang_dipisahkan,
      lain_lain_pad: p.lain_lain_pad,
    });
  };

  /* ── chart options ── */
  const barOpts = {
    maintainAspectRatio: false,
    animation: false,
    plugins: { legend: { labels: { color:"#94a3b8", font:{ size:12 } } } },
    scales: {
      x: { ticks:{ color:"#94a3b8" }, grid:{ color:"rgba(255,255,255,0.05)" } },
      y: { ticks:{ color:"#94a3b8", callback: v => "Rp "+Intl.NumberFormat("id-ID",{notation:"compact"}).format(v) },
           grid:{ color:"rgba(255,255,255,0.05)" } },
    },
  };
  const pieOpts = {
    maintainAspectRatio: false,
    animation: false,
    plugins: { legend: { position:"right", labels:{ color:"#94a3b8", padding:16, font:{size:11} } } },
  };

  const TABS = ["PAD","Pajak","Retribusi"];

  /* ─────────────────────────────────────────────────────────────── */
  return (
    <>
      <style>{`
        /* ── Reset & tokens ── */
        *, *::before, *::after { box-sizing: border-box; margin:0; padding:0; }

        :root {
          --navy:   #0a0f1e;
          --navy2:  #0d1528;
          --card:   #111827;
          --card2:  #1a2233;
          --border: rgba(99,120,180,0.18);
          --gold:   #f0a500;
          --gold2:  #fbbf24;
          --teal:   #14b8a6;
          --blue:   #3b82f6;
          --text:   #e2e8f0;
          --muted:  #64748b;
          --radius: 14px;
          --transition: .35s cubic-bezier(.4,0,.2,1);
          font-family: 'Segoe UI', system-ui, sans-serif;
        }

        body { background: var(--navy); color: var(--text); }

        /* ── Page fade-in ── */
        .bp-page { opacity:0; transform:translateY(12px); transition: opacity .6s ease, transform .6s ease; }
        .bp-page.mounted { opacity:1; transform:translateY(0); }

        /* ════════════ HERO ════════════ */
        .bp-hero {
          position: relative;
          height: 560px;
          overflow: hidden;
          background: var(--navy);
        }
        .bp-hero-track {
          display: flex;
          height: 100%;
          transition: transform .7s cubic-bezier(.77,0,.18,1);
        }
        .bp-hero-track img {
          min-width: 100%;
          height: 100%;
          object-fit: cover;
          flex-shrink: 0;
        }
        .bp-hero-overlay {
          position: absolute; inset:0;
          background: linear-gradient(to top, rgba(10,15,30,.92) 0%, rgba(10,15,30,.35) 50%, transparent 100%);
        }
        /* dots */
        .bp-hero-dots {
          position: absolute; bottom:80px; left:50%; transform:translateX(-50%);
          display: flex; gap:8px; z-index:4;
        }
        .bp-hero-dots span {
          width:8px; height:8px; border-radius:50%;
          background: rgba(255,255,255,.35);
          cursor:pointer; transition: background .3s, transform .3s;
        }
        .bp-hero-dots span.active { background: var(--gold); transform: scale(1.3); }
        /* arrows */
        .bp-hero-arrow {
          position:absolute; top:50%; transform:translateY(-50%);
          z-index:5; background: rgba(255,255,255,.12); border:none;
          color:#fff; width:44px; height:44px; border-radius:50%;
          font-size:20px; cursor:pointer; backdrop-filter:blur(6px);
          transition: background var(--transition);
          display:flex; align-items:center; justify-content:center;
        }
        .bp-hero-arrow:hover { background: rgba(240,165,0,.75); }
        .bp-hero-arrow.left  { left:24px; }
        .bp-hero-arrow.right { right:24px; }
        /* caption */
        .bp-hero-caption {
          position:absolute; bottom:0; left:0; right:0;
          padding: 24px 40px; z-index:4;
        }
        .bp-hero-caption p {
          font-size: clamp(16px, 2.5vw, 22px);
          font-weight: 600; color:#fff;
          text-shadow: 0 2px 12px rgba(0,0,0,.6);
          max-width: 700px;
        }

        /* ════════════ MARQUEE ════════════ */
        .bp-marquee {
          background: linear-gradient(90deg, var(--gold) 0%, #f59e0b 100%);
          color: var(--navy);
          font-weight: 700; font-size: 13px;
          letter-spacing: .03em; padding: 10px 0;
        }

        /* ════════════ SECTION WRAPPERS ════════════ */
        .bp-section { padding: 72px 0; }
        .bp-section.alt { background: var(--navy2); }
        .bp-container { max-width: 1200px; margin:0 auto; padding: 0 24px; }

        .bp-section-head {
          display:flex; align-items:center; justify-content:space-between;
          margin-bottom: 40px;
        }
        .bp-section-title {
          font-size: clamp(20px, 3vw, 28px);
          font-weight: 700; color:#fff; letter-spacing:-.02em;
        }
        .bp-section-title span {
          display:inline-block;
          border-bottom: 3px solid var(--gold);
          padding-bottom: 2px;
        }
        .bp-see-all {
          display:flex; align-items:center; gap:6px;
          color: var(--gold); font-size:13px; font-weight:600;
          text-decoration:none; transition: gap .25s;
        }
        .bp-see-all:hover { gap:10px; }

        /* ════════════ APPS CARDS ════════════ */
        .bp-apps { display:grid; grid-template-columns:repeat(3,1fr); gap:30px; }
        @media(max-width:640px){ .bp-apps { grid-template-columns:1fr; } }
        .bp-app-card {
          background: var(--card); border:1px solid var(--border);
          border-radius: var(--radius); padding:28px 24px;
          display:flex; flex-direction:column; align-items:center; gap:14px;
          text-decoration:none; transition: transform var(--transition), box-shadow var(--transition), border-color var(--transition);
        }
        .bp-app-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 40px rgba(0,0,0,.5);
          border-color: var(--gold);
        }
        .bp-app-card img { height:95px; object-fit:contain; }
        .bp-app-card span { font-size:12px; color:var(--muted); font-weight:500; letter-spacing:.04em; text-transform:uppercase; }

        /* ════════════ CHART SECTION ════════════ */
        .bp-tabs { display:flex; gap:4px; margin-bottom:28px; }
        .bp-tab {
          padding: 8px 20px; border-radius: 8px; border:none;
          font-size: 13px; font-weight:600; cursor:pointer;
          background: var(--card2); color:var(--muted);
          transition: background var(--transition), color var(--transition);
        }
        .bp-tab.active { background:var(--gold); color:var(--navy); }

        .bp-chart-box {
          background: var(--card); border:1px solid var(--border);
          border-radius: var(--radius); padding:28px; overflow:hidden;
        }
        .bp-chart-title { font-size:15px; font-weight:600; color:var(--text); margin-bottom:20px; }
        .bp-chart-wrap  { height:280px; margin-bottom:28px; }

        /* chart table */
        .bp-table { width:100%; border-collapse:collapse; font-size:13px; }
        .bp-table thead tr { background:var(--card2); }
        .bp-table th { padding:10px 14px; text-align:left; color:var(--muted); font-weight:600; font-size:12px; letter-spacing:.04em; text-transform:uppercase; }
        .bp-table td { padding:10px 14px; color:var(--text); border-top:1px solid var(--border); }
        .bp-table tbody tr:hover { background:rgba(255,255,255,.03); }
        .bp-pct { display:inline-block; padding:2px 8px; border-radius:20px; font-size:11px; font-weight:700;
          background:rgba(20,184,166,.15); color:var(--teal); }

        /* ════════════ NEWS GRID ════════════ */
        .bp-news-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:20px; }
        @media(max-width:900px){ .bp-news-grid { grid-template-columns:repeat(2,1fr); } }
        @media(max-width:540px){ .bp-news-grid { grid-template-columns:1fr; } }

        .bp-news-card {
          background:var(--card); border:1px solid var(--border);
          border-radius:var(--radius); overflow:hidden;
          transition: transform var(--transition), box-shadow var(--transition);
          display:flex; flex-direction:column;
        }
        .bp-news-card:hover { transform:translateY(-5px); box-shadow:0 16px 40px rgba(0,0,0,.45); }
        .bp-news-card img { width:100%; height:180px; object-fit:cover; display:block; }
        .bp-news-card-body { padding:16px; flex:1; display:flex; flex-direction:column; gap:8px; }
        .bp-news-date { display:flex; align-items:center; gap:5px; color:var(--muted); font-size:11px; }
        .bp-news-title { font-size:13px; font-weight:600; color:var(--text); line-height:1.5; text-decoration:none; }
        .bp-news-title:hover { color:var(--gold); }

        /* ════════════ VIDEO ════════════ */
        .bp-video-grid { display:grid; grid-template-columns:1.6fr 1fr; gap:28px; }
        @media(max-width:768px){ .bp-video-grid { grid-template-columns:1fr; } }

        .bp-video-main { border-radius:var(--radius); overflow:hidden; background:var(--card); border:1px solid var(--border); }
        .bp-video-main iframe, .bp-video-main > div > iframe { width:100% !important; border-radius:var(--radius); }

        .bp-video-list { display:flex; flex-direction:column; gap:12px; }
        .bp-video-item {
          background:var(--card); border:1px solid var(--border); border-radius:12px;
          overflow:hidden; cursor:pointer; display:flex; align-items:stretch;
          transition: border-color var(--transition), box-shadow var(--transition);
        }
        .bp-video-item:hover { border-color:var(--gold); box-shadow:0 8px 24px rgba(0,0,0,.35); }
        .bp-video-item.active { border-color:var(--gold); }
        .bp-video-thumb { position:relative; width:110px; flex-shrink:0; }
        .bp-video-thumb img { width:100%; height:100%; object-fit:cover; display:block; }
        .bp-video-thumb-overlay {
          position:absolute; inset:0; background:rgba(0,0,0,.45);
          display:flex; align-items:center; justify-content:center;
          color:#fff; transition: background var(--transition);
        }
        .bp-video-item:hover .bp-video-thumb-overlay { background:rgba(240,165,0,.6); }
        .bp-video-info { padding:12px; display:flex; flex-direction:column; justify-content:center; gap:4px; }
        .bp-video-info p { font-size:12px; color:var(--text); font-weight:600; line-height:1.4; }
        .bp-video-info span { font-size:11px; color:var(--muted); }

        /* ════════════ INSTAGRAM ════════════ */
        .bp-ig-wrap { background:var(--card); border:1px solid var(--border); border-radius:var(--radius); padding:28px; }

        /* ════════════ LINKS ════════════ */
        .bp-links-grid { display:flex; flex-wrap:wrap; gap:20px; }
        .bp-link-card {
          background:var(--card); border:1px solid var(--border); border-radius:12px;
          padding:20px 28px; display:flex; align-items:center; gap:16px;
          text-decoration:none; transition: all var(--transition);
        }
        .bp-link-card:hover { border-color:var(--gold); transform:translateY(-3px); }
        .bp-link-card img { height:126px; object-fit:contain; }
        .bp-link-card span { font-size:13px; font-weight:600; color:var(--text); }

        /* ════════════ COUNTER ════════════ */
        .bp-counter-box {
          display:inline-flex; align-items:center; gap:16px;
          background:var(--card); border:1px solid var(--border);
          border-radius:12px; padding:20px 28px;
        }
        .bp-counter-label { font-size:13px; color:var(--muted); font-weight:500; }

        /* ════════════ STATS PILL ROW ════════════ */
        .bp-stat-row { display:flex; gap:12px; flex-wrap:wrap; margin-bottom:24px; }
        .bp-stat-pill {
          background:var(--card2); border:1px solid var(--border); border-radius:20px;
          padding:7px 16px; font-size:12px; font-weight:600; color:var(--muted);
          display:flex; align-items:center; gap:6px;
        }
        .bp-stat-pill b { color:var(--text); }
      `}</style>

      <div className={`bp-page${mounted ? " mounted" : ""}`}>
        <Header active="beranda" />

        {/* ── HERO ── */}
        <section className="bp-hero">
          <div
            className="bp-hero-track"
            style={{ transform: `translateX(-${slideIndex * 100}%)` }}
          >
            {banner.length > 0
              ? banner.map((b, i) => (
                  <img key={i} src={BaseURL + "assets/images/banner/" + b.thumbnail} alt="" />
                ))
              : [hero1, hero2].map((s, i) => <img key={i} src={s} alt="" />)
            }
          </div>
          <div className="bp-hero-overlay" />

          <button className="bp-hero-arrow left"
            onClick={() => setSlideIndex(p => (p === 0 ? (banner.length||1)-1 : p-1))}>
            ‹
          </button>
          <button className="bp-hero-arrow right"
            onClick={() => setSlideIndex(p => (p === (banner.length||1)-1 ? 0 : p+1))}>
            ›
          </button>

          <div className="bp-hero-dots">
            {(banner.length > 0 ? banner : [0,1]).map((_, i) => (
              <span key={i} className={i === slideIndex ? "active" : ""} onClick={() => setSlideIndex(i)} />
            ))}
          </div>

          <a href={banner.length > 0 ? banner[slideIndex]?.link : "#"} target="_blank" rel="noreferrer" className="bp-hero-caption">
            <p>{banner.length > 0 ? banner[slideIndex]?.judul : "Badan Pendapatan Daerah Kota Bekasi"}</p>
          </a>
        </section>

        {/* ── MARQUEE ── */}
        <div className="bp-marquee">
          <marquee direction="left">
            🏛️ Selamat datang di website Badan Pendapatan Daerah Kota Bekasi &nbsp;|&nbsp;
            Layanan prima untuk wajib pajak Kota Bekasi &nbsp;|&nbsp;
            Informasi pajak daerah tersedia di sini
          </marquee>
        </div>

        {/* ── APLIKASI ── */}
        <section className="bp-section">
          <div className="bp-container">
            <div className="bp-section-head">
              <h2 className="bp-section-title"><span>Aplikasi Layanan</span></h2>
            </div>
            <div className="bp-apps">
              {[
                { href:"https://ebphtb.bekasikota.go.id/", img:logoEbphtb, label:"e-BPHTB" },
                { href:"https://sipdah.bekasikota.go.id/", img:logoEsptpd, label:"e-SPTPD" },
                { href:"https://e-pbb.bekasikota.go.id/", img:logoPembebasan, label:"Pembebasan Pengurangan PBB-P2" },
                { href:"https://play.google.com/store/apps/details?id=com.depisista.infopbb", img:ipbb, label:"Info PBB" },
              ].map((a, i) => (
                <a key={i} href={a.href} target="_blank" rel="noreferrer" className="bp-app-card">
                  <img src={a.img} alt={a.label} />
                  <span>{a.label}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ── PENDAPATAN DAERAH ── */}
        <section className="bp-section alt">
          <div className="bp-container">
            <div className="bp-section-head">
              <h2 className="bp-section-title"><span>Info Pendapatan Daerah</span></h2>
            </div>
            <div className="bp-tabs">
              {TABS.map(t => (
                <button key={t} className={`bp-tab${chartActive===t?" active":""}`} onClick={() => setChartActive(t)}>
                  {t}
                </button>
              ))}
            </div>

            {/* PAD */}
            {chartActive === "PAD" && (
              <div className="bp-chart-box">
                <div className="bp-chart-title">Target PAD Tahun {pad.tahun}</div>
                <div className="bp-chart-wrap">
                  <Pie data={{
                    labels: pad.label,
                    datasets:[{ data:[pad.pajak_daerah,pad.retribusi_daerah,pad.kd_yang_dipisahkan,pad.lain_lain_pad],
                      backgroundColor:["#f0a500","#14b8a6","#3b82f6","#a78bfa"],
                      borderColor:"transparent", hoverOffset:6 }]
                  }} options={pieOpts} />
                </div>
                <table className="bp-table">
                  <thead><tr><th>No</th><th>Keterangan</th><th>Nilai</th></tr></thead>
                  <tbody>
                    {[
                      ["Pajak Daerah", pad.pajak_daerah],
                      ["Retribusi Daerah", pad.retribusi_daerah],
                      ["Kekayaan Daerah Dipisahkan", pad.kd_yang_dipisahkan],
                      ["Lain-lain PAD", pad.lain_lain_pad],
                    ].map(([k,v],i)=>(
                      <tr key={i}><td>{i+1}</td><td>{k}</td><td>{formatIDR(v)}</td></tr>
                    ))}
                    <tr style={{fontWeight:700}}>
                      <td></td><td>Total PAD</td>
                      <td style={{color:"var(--gold)"}}>
                        {formatIDR(+pad.pajak_daerah + +pad.retribusi_daerah + +pad.kd_yang_dipisahkan + +pad.lain_lain_pad)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {/* Pajak */}
            {chartActive === "Pajak" && (
              <div className="bp-chart-box">
                <div className="bp-chart-title">Realisasi Pajak Daerah</div>
                <div className="bp-chart-wrap">
                  <Bar data={{
                    labels: pajak.label,
                    datasets:[
                      { label:"Target",    data:pajak.target,    backgroundColor:"rgba(240,165,0,.8)", borderRadius:4 },
                      { label:"Realisasi", data:pajak.realisasi, backgroundColor:"rgba(59,130,246,.8)", borderRadius:4 },
                    ]
                  }} options={barOpts} />
                </div>
                <table className="bp-table">
                  <thead><tr><th>No</th><th>Tahun</th><th>Target</th><th>Realisasi</th><th>%</th></tr></thead>
                  <tbody>
                    {pajak.all.map((item,i)=>{
                      const pct = item.target > 0 ? (item.realisasi*100/item.target).toFixed(1) : "100.0";
                      return <tr key={i}><td>{i+1}</td><td>{item.tahun}</td>
                        <td>{formatIDR(item.target)}</td><td>{formatIDR(item.realisasi)}</td>
                        <td><span className="bp-pct">{pct}%</span></td></tr>;
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {/* Retribusi */}
            {chartActive === "Retribusi" && (
              <div className="bp-chart-box">
                <div className="bp-chart-title">Realisasi Retribusi Daerah</div>
                <div className="bp-chart-wrap">
                  <Bar data={{
                    labels: retribusi.label,
                    datasets:[
                      { label:"Target",    data:retribusi.target,    backgroundColor:"rgba(240,165,0,.8)", borderRadius:4 },
                      { label:"Realisasi", data:retribusi.realisasi, backgroundColor:"rgba(20,184,166,.8)", borderRadius:4 },
                    ]
                  }} options={barOpts} />
                </div>
                <table className="bp-table">
                  <thead><tr><th>No</th><th>Tahun</th><th>Target</th><th>Realisasi</th><th>%</th></tr></thead>
                  <tbody>
                    {retribusi.all.map((item,i)=>{
                      const pct = item.target > 0 ? (item.realisasi*100/item.target).toFixed(1) : "100.0";
                      return <tr key={i}><td>{i+1}</td><td>{item.tahun}</td>
                        <td>{formatIDR(item.target)}</td><td>{formatIDR(item.realisasi)}</td>
                        <td><span className="bp-pct">{pct}%</span></td></tr>;
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </section>

       {/* ── BERITA ── */}
<section className="bp-section">
  <div className="bp-container">
    <div className="bp-section-head">
      <h2 className="bp-section-title">
        <span>Berita Terkini</span>
      </h2>
      <Link to="/berita" className="bp-see-all">
        Lihat semua <IconArrow />
      </Link>
    </div>

    <div className="bp-news-grid">
      {Array.isArray(berita) && berita.length > 0 ? (
        berita.map((item) => (
          <div className="bp-news-card" key={item?.id_berita}>
            <img
              src={
                item?.thumbnail
                  ? BaseURL + "assets/images/berita/" + item.thumbnail
                  : "/no-image.png"
              }
              alt={item?.judul || "berita"}
            />

            <div className="bp-news-card-body">
              <div className="bp-news-date">
                <IconCalendar /> {item?.created_date || "-"}
              </div>

              <Link
                to={"/berita-detail/" + (item?.id_berita || "")}
                className="bp-news-title"
              >
                {item?.judul || "-"}
              </Link>
            </div>
          </div>
        ))
      ) : (
        <div style={{ padding: "20px", textAlign: "center" }}>
          Tidak ada berita
        </div>
      )}
    </div>
  </div>
</section>

        {/* ── AGENDA ── */}
        <section className="bp-section alt">
          <div className="bp-container">
            <div className="bp-section-head">
              <h2 className="bp-section-title"><span>Agenda</span></h2>
              <Link to="/agenda" className="bp-see-all">Lihat semua <IconArrow /></Link>
            </div>
            <div className="bp-news-grid">
              {agenda.map((item) => (
                <div className="bp-news-card" key={item.id_agenda}>
                  <img src={BaseURL + "assets/images/agenda/" + item.thumbnail} alt={item.judul} />
                  <div className="bp-news-card-body">
                    <div className="bp-news-date"><IconCalendar />{item.created_date}</div>
                    <Link to={"/agenda-detail/" + item.id_agenda} className="bp-news-title">
                      {item.judul}
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── VIDEO + INSTAGRAM ── */}
        <section className="bp-section">
          <div className="bp-container">
            <div className="bp-section-head">
              <h2 className="bp-section-title"><span>Berita Video</span></h2>
              <Link to="/berita-video" className="bp-see-all">Lihat semua <IconArrow /></Link>
            </div>
            <div className="bp-video-grid">
              {/* main player */}
              <div className="bp-video-main">
                {youtubePlay?.id_video && (
                  <YouTube videoId={youtubePlay.id_video} className="youtube-iframe"
                    opts={{ width:"100%", playerVars:{ autoplay:0 } }} />
                )}
              </div>
              {/* playlist */}
              <div className="bp-video-list">
                {beritaVideo.map((item, i) => (
                  <div key={item.id||i}
                    className={`bp-video-item${youtubePlay?.id_video===item.id_video?" active":""}`}
                    onClick={() => setYoutubePlay(item)}>
                    <div className="bp-video-thumb">
                      <img src={item.thumbnail || "https://via.placeholder.com/110x80?text=..."} alt={item.judul} />
                      <div className="bp-video-thumb-overlay"><IconPlay /></div>
                    </div>
                    <div className="bp-video-info">
                      <p>{item.judul}</p>
                      <span>Klik untuk putar</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Instagram */}
            <div style={{marginTop:48}}>
              <div className="bp-section-head" style={{marginBottom:24}}>
                <h2 className="bp-section-title"><span>Instagram</span></h2>
              </div>
              <div className="bp-ig-wrap">
            
<a href="https://www.instagram.com/bapenda_kotabekasi/" target="_blank">
  <img src={logoInstagram} />
</a>
              </div>
            </div>
          </div>
        </section>

        {/* ── TAUTAN ── */}
        <section className="bp-section alt">
          <div className="bp-container">
            <div className="bp-section-head">
              <h2 className="bp-section-title"><span>Link / Tautan</span></h2>
            </div>
            <div className="bp-links-grid">
              <a href="https://www.bekasikota.go.id/" target="_blank" rel="noreferrer" className="bp-link-card">
                <img src={logoBekasi} alt="Pemkot Bekasi" />
                <span>Pemerintah Kota Bekasi</span>
              </a>
              <a href="https://spse.inaproc.id/bekasikota" target="_blank" rel="noreferrer" className="bp-link-card">
                <img src={lpse} alt="LPSE" />
                <span>LPSE Kota Bekasi</span>
              </a>
             <a href="https://wbs.bekasikota.go.id/" target="_blank" rel="noreferrer" className="bp-link-card">
  <img 
    src={wbs} 
    alt="WBS"
    style={{ width: "120px", height: "auto" }}
  />
</a>
            </div>

            <div style={{marginTop:48}}>
              <div className="bp-section-head" style={{marginBottom:16}}>
                <h2 className="bp-section-title"><span>Total Pengunjung</span></h2>
              </div>
              <div className="bp-counter-box">
                <span className="bp-counter-label">Visitor counter</span>
                <div id="histats_counter" />
              </div>
            </div>
          </div>
        </section>

        <SubFooter />
        <Footer />
      </div>
    </>
  );
};

export default Beranda;